export const CompanyThemeModeEnum = {
    LIGHT: "light",
    DARK: "dark",
    CUSTOM: "custom",
  }